import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import shortid from 'shortid';
import CircleText from '../CircleText';
import styles from './Legend.module.css';

const renderCircleText = (specs) => {
  const {
    color,
    text,
    ...otherProps
  } = specs;

  return (
    <CircleText
      circleColor={color}
      circleSize={8}
      bordered
      {...otherProps}
    >
      {text}
    </CircleText>
  );
};

const Legend = ({
  className = '',
  data = [],
  id = '',
  mode = 'vertical',
  ...otherProps
}) => {

  const classes = classNames(
    styles.legend,
    {
      [styles.vertical]: mode === 'vertical',
      [styles.horizontal]: mode === 'horizontal',
    },
    className,
  );

  const containerid = id || `legend-${shortid.generate()}`;

  const rows = data.map((row, index) => {
    const rowid = `${containerid}-row${index}`;
    return (
      <div
        className={styles.row}
        id={rowid}
        key={rowid}
      >
        {renderCircleText(row)}
      </div>
    );
  });

  return (
    <div
      className={classes}
      id={containerid}
      {...otherProps}
    >
      {rows}
    </div>
  );
};



Legend.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  data: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array,
      PropTypes.object,
    ]),
  })),
  mode: PropTypes.oneOf([
    'vertical',
    'horizontal',
  ]),
  id: PropTypes.string,
};

export default Legend;